import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, ApplyButton, CheckBox } from '_components';
import styles from './Common.module.css';
import { Modal } from 'react-bootstrap'
import {
    AlTemplateTherAct,
    AlTemplateSelfCare,
    AlTemplateNeuro,
    AlTemplateTherEx,
    AlTemplateManual,
    AlTemplateGait,
    AlTemplateAqua,
    AlTemplateMod,
    AlTemplateOther,
    AlTemplatePhysPerfTest
} from 'PatientCareCenter/Note/AL/Templates';


class AlTemplateDialog extends React.Component {


    apply() {
        this.props.applyTemplate(this.props.noteId);
    }

    cancel() {
        this.props.cancelTemplate(this.props.noteId);
    }

    render() {
        return (
            <Modal show={true} backdrop='static' keyboard={false} dialogClassName={styles.dialog}>
                <div className={styles.title} title={'Customize Template - ' + this.props.template.XLTMPNAME}>
                    {'Customize Template - ' + this.props.template.XLTMPNAME}
                </div>
                <div className={styles.description}>{this.props.template.XLTMPDESC}</div>
                <div className={styles.selectall}>
                    <CheckBox
                        size='extra-small'
                        checked={this.props.allSelected}
                        onClick={() => this.props.toggleAllSelected({ noteId: this.props.noteId, value: !this.props.allSelected })}
                    />
                </div>
                <div className={styles.content}>
                    <AlTemplateTherAct />
                    <AlTemplateSelfCare />
                    <AlTemplateNeuro />
                    <AlTemplateTherEx />
                    <AlTemplateManual />
                    <AlTemplateGait />
                    <AlTemplateAqua />
                    <AlTemplateMod />
                    <AlTemplateOther />
                    <AlTemplatePhysPerfTest />
                </div>
                <div className={styles.buttons}>
                    <span className={styles.button_wrapper}>
                        <ApplyButton size='small' title='Apply Template' onClick={() => this.apply()} />
                    </span>
                    <span className={styles.button_wrapper}>
                        <CancelButton size='small' title='Cancel' onClick={() => this.cancel()} />
                    </span>
                </div>
            </Modal>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        applyTemplate: bindActionCreators(noteActions.applyAlTemplate, dispatch),
        cancelTemplate: bindActionCreators(noteActions.cancelAlTemplate, dispatch),
        toggleAllSelected: bindActionCreators(noteActions.alTemplateToggleAllSelected, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let templateVisible = state.ui.notes[noteId].alTemplateVisible;
    let template = state.entities.notes.MLTEMPLATE[state.ui.notes[noteId].alTmpno + '_' + noteId];
    let allSelected = state.ui.notes[noteId].alTemplateAllSelected;

    return {
        noteId: noteId,
        xlno: xlno,
        template: template,
        templateVisible: templateVisible,
        allSelected: allSelected
    };
}

const connectedAlTemplateDialog = connect(mapStateToProps, mapDispatchToProps)(AlTemplateDialog);
export { connectedAlTemplateDialog as AlTemplateDialog };

